import Model from '@/models/Model'

export default class ADispatch extends Model {
    resource() {
        return 'dispatch'
    }
}